import React, { FunctionComponent, useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

interface Props {
    title: string;
    onChange?: (expanded: boolean) => void;
    expandable?: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#ffffff',
            border: '1px solid #D3D3D3',
            whiteSpace: 'nowrap',
            [theme.breakpoints.down('lg')]: {
                borderRadius: 28,
                height: 32,
                paddingLeft: 12,
                paddingRight: 12
            },
            [theme.breakpoints.up('xl')]: {
                borderRadius: 37,
                height: 42,
                paddingLeft: 16,
                paddingRight: 16
            }
        },
        title: {
            [theme.breakpoints.down('lg')]: {
                fontSize: 12
            },
            [theme.breakpoints.up('xl')]: {
                fontSize: 16
            }
        },
        icon: {
            [theme.breakpoints.down('lg')]: {
                fontSize: 14,
                marginLeft: 10
            },
            [theme.breakpoints.up('xl')]: {
                fontSize: 16,
                marginLeft: 20
            }
        }
    })
);

export const PriceServicesRowContent: FunctionComponent<Props> = props => {
    const classes = useStyles();

    const [expanded, setExpanded] = useState(false);

    const clickHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.stopPropagation();
        props.onChange && props.onChange(!expanded);
        setExpanded(prev => {
            return !prev;
        });
    };

    const expandableIcon = (
        <FontAwesomeIcon
            icon={expanded ? faCaretUp : faCaretDown}
            className={classes.icon}
        />
    );

    const notExpandableIcon = (
        <FontAwesomeIcon
            icon={faChevronRight}
            className={classes.icon}
        />
    );

    const icon = props.expandable ? expandableIcon : notExpandableIcon;

    return (
        // Permitir hacer click sobre el variable price button
        <Box
            className={clsx(classes.container, props.className)}
            onClick={clickHandler}
        >
            <Typography className={classes.title}>{props.title}</Typography>
            {icon}
        </Box>
    );
};

export default PriceServicesRowContent;
